
(function() {
  if (typeof algoliasearch === 'undefined') {
    console.warn('algoliasearch is not loaded. find-doctor-url-params.js requires algoliasearch.');
    return;
  }

  const searchClient = algoliasearch.algoliasearch('P0Z7SW5ST1', '6ae1c924d6fbc5a4087e7310781f29b1');

  async function getDoctorByObjectIDGlobal(objectID, query = '') {
    try {
      if (!objectID) {
        console.log('No objectID provided.');
        return;
      }

      const { results } = await searchClient.search([
        {
          indexName: 'PROD_PRN_DOC',
          filters: `objectID:${objectID}`,
          query
        },
        { 
          indexName: 'PROD_PRN_HOS',
          filters: `objectID:${objectID}`,
          query
        }
      ]);

      if (!results?.length || !results[0]?.hits?.length && !results[1]?.hits?.length) {
        console.log('No doctor found.');
        return;
      }

      
      const doctorData = results[0]?.hits?.length > 0 ? results[0].hits[0] : results[1].hits[0];
      const indexName = results[0]?.hits?.length > 0 ? 'PROD_PRN_DOC' : 'PROD_PRN_HOS';
      
      const { _highlightResult, ...doctorWithoutHighlightResult } = doctorData;
      const addressParts = [doctorData.parent, doctorData.address?.city, doctorData.address?.line_1, doctorData.address?.region, doctorData.address?.postalCode, doctorData.address?.country].filter(Boolean);
      const addressString = addressParts.join(', ');

      const nameToDisplay = doctorData.name.includes(':') 
        ? doctorData.name.split(':')[1].trim() 
        : doctorData.name;

      localStorage.setItem('selectedDoctor', JSON.stringify({
        name: nameToDisplay,
        address: addressString,
        id: doctorData.objectID,
        indexName: indexName,
        objectData: doctorWithoutHighlightResult,
      }));
      return true;
    } catch (err) {
      console.error('Error fetching doctor:', err);
      return false;
    }
  }

  async function getDoctorByAffiliateCodeGlobal(affiliateCode, query = '') {
    try {
      if (!affiliateCode) {
        console.log('No affiliateCode provided.');
        return;
      }

      const { results } = await searchClient.search([
        {
          indexName: 'PROD_PRN_DOC',
          filters: `affiliateCode:${affiliateCode}`,
          query
        },
        { 
          indexName: 'PROD_PRN_HOS',
          filters: `affiliateCode:${affiliateCode}`,
          query
        }
      ]);

      if (!results?.length || !results[0]?.hits?.length && !results[1]?.hits?.length) {
        console.log('No doctor found with this affiliateCode.');
        return;
      }
      
      const doctorData = results[0]?.hits?.length > 0 ? results[0].hits[0] : results[1].hits[0];
      const indexName = results[0]?.hits?.length > 0 ? 'PROD_PRN_DOC' : 'PROD_PRN_HOS';
      
      const { _highlightResult, ...doctorWithoutHighlightResult } = doctorData;
      const addressParts = [doctorData.parent, doctorData.address?.city, doctorData.address?.line_1, doctorData.address?.region, doctorData.address?.postalCode, doctorData.address?.country].filter(Boolean);
      const addressString = addressParts.join(', ');

      const nameToDisplay = doctorData.name.includes(':') 
        ? doctorData.name.split(':')[1].trim() 
        : doctorData.name;

      localStorage.setItem('selectedDoctor', JSON.stringify({
        name: nameToDisplay,
        address: addressString,
        id: doctorData.objectID,
        indexName: indexName,
        objectData: doctorWithoutHighlightResult,
      }));
      return true;
    } catch (err) {
      console.error('Error fetching doctor by affiliateCode:', err);
      return false;
    }
  }

  async function processUrlParams() {
    const storedDoctor = localStorage.getItem('selectedDoctor');
        
    if (storedDoctor) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const adiParam = urlParams.get('adi');
    const affiliateCodeParam = urlParams.get('affiliateCode');

    if (adiParam) {
      await getDoctorByObjectIDGlobal(adiParam);
    } else if (affiliateCodeParam) {
      await getDoctorByAffiliateCodeGlobal(affiliateCodeParam);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processUrlParams);
  } else {
    processUrlParams();
  }

  window.FindDoctorUtils = {
    getDoctorByObjectID: getDoctorByObjectIDGlobal,
    getDoctorByAffiliateCode: getDoctorByAffiliateCodeGlobal
  };
})();

